"use client"

import Link from "next/link"

import { useExt } from "@/hooks/use-ext"

const linkClass =
  "text-left text-[14px] leading-5 font-normal text-[#1D2129] hover:text-[#0F9E4F] hover:underline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#0F9E4F]"

export default function FooterEarnMoneyLink() {
  const isReady = useExt()

  if (!isReady) {
    return (
      <Link href="/how-to-use" className={linkClass}>
        Snap to Earn Money
      </Link>
    )
  }

  return (
    <button
      type="button"
      className={linkClass}
      onClick={() =>
        window.postMessage({ action: "open-extension-sidepanel" }, "*")
      }
    >
      Snap to Earn Money
    </button>
  )
}
